import { ApiError } from "@/api/client";
import { unauthorizedMessage } from "@/lib/auth/unauthorizedMessage";

export function formatUnauthorizedQueryError(): string {
  return unauthorizedMessage();
}

export function formatApiQueryError(
  err: unknown,
  fallback: string,
  options?: {
    forbidden?: string;
    statusPrefix?: string;
  },
): string {
  if (err instanceof ApiError) {
    if (err.status === 401) return unauthorizedMessage();
    if (err.status === 403 && options?.forbidden) return options.forbidden;
    if (err.message) return err.message;
    if (options?.statusPrefix) return `${options.statusPrefix} (${err.status})`;
  }
  return fallback;
}

export function formatNetworkQueryError(
  err: unknown,
  fallback: string,
): string {
  if (err instanceof TypeError && err.message.toLowerCase().includes("fetch")) {
    return "Сетевая ошибка. Проверьте подключение или откройте сайт через http://localhost:5173";
  }
  if (err instanceof ApiError && err.message) return err.message;
  return fallback;
}
